import * as React from 'react';
import { Notification } from '../Notification';
import useStyles from './styles';
export const NotificationStack = ({ notifications, closeNotification, }) => {
    const classes = useStyles();
    return (React.createElement("div", { className: classes.stack }, notifications.map((notification) => (React.createElement(Notification, { key: notification.notificationNumber, type: notification.type, msg: notification.msg, timer: notification.timer, notificationNumber: notification.notificationNumber, closeNotification: closeNotification })))));
};
